import { render, staticRenderFns } from "./ResortViewClient.vue?vue&type=template&id=09fd5fa1&scoped=true"
import script from "./ResortViewClient.vue?vue&type=script&lang=js"
export * from "./ResortViewClient.vue?vue&type=script&lang=js"
import style0 from "./ResortViewClient.vue?vue&type=style&index=0&id=09fd5fa1&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+compiler-sfc@3.5.40_babel-core@6.26.3_css-loader@6.11.0_webpack_803fd858e391fe10e6ea2ea3dda7e9cc/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "09fd5fa1",
  null
  
)

export default component.exports